/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMsal } from '@azure/msal-react';
import styled from '@emotion/styled';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Backdrop from '@mui/material/Backdrop';
import Badge from '@mui/material/Badge';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { selectAuthUser } from '../../../store/auth/selector';
import { logout } from '../../../store/auth/slice';
import { selectProfile } from '../../../store/profile/selector';
import { layoutPrivateStyle } from '../../../styles/layout/private-routes';
import { MobileMenuProps } from '../../../types/mobile-menu';
// import { ProfileMenuProps } from '../../../types/modul-login';
// import { callMsGraph } from 'utils/graph';

import { Notification } from '../notification';
import { ModulProfileMenu } from './modul-profile-menu';

type GraphProps = {
  displayName: string;
  userPrincipalName: string;
};

export function Header({ mobileMenu, setMobileMenu }: MobileMenuProps) {
  const navigate = useNavigate();
  const user = useSelector(selectProfile);
  const profile = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const { id } = useParams();

  const [profileMenu, setProfileMenu] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [badgeInvisible, setBadgeInvisible] = useState(true);

  const [activeMenu, setActiveMenu] = useState('Dashboard');
  const location = useLocation();

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const linkLists = [
    {
      name: 'Dashboard',
      // icon: <DashboardIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: '/',
      key: '',
      collapseList: [],
    },
    {
      name: 'Project',
      // icon: <SupervisorAccountIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: '/project',
      key: '',
      collapseList: [],
    },
    {
      name: 'Article',
      // icon: <EditOutlinedIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: '/article-list',
      key: '',
      collapseList: [],
    },
    {
      name: 'User',
      // icon: <AppSettingsAltIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: '/user',
      key: '',
      collapseList: [],
    },
  ];

  useEffect(() => {
    const path = location.pathname;

    switch (path) {
      case '/article-list':
        setActiveMenu('Article');
        break;
      case `/article-detail/${id}`:
        setActiveMenu('Article');
        break;
      case '/project':
        setActiveMenu('Project');
        break;
      case `/project-detail/${id}`:
        setActiveMenu('Project');
        break;
      case '/create-project':
        setActiveMenu('Project');
        break;
      case `/edit-project/${id}`:
        setActiveMenu('Project');
        break;
      case '/user':
        setActiveMenu('User');
        break;
      case `/user-detail/${id}`:
        setActiveMenu('User');
        break;
      case `/detail-user/${id}/edit`:
        setActiveMenu('User');
        break;
      case `/profile`:
        setActiveMenu('User');
        break;
      default:
        setActiveMenu('Dashboard');
    }
  }, [location.pathname]);

  return (
    <AppBar sx={layoutPrivateStyle.header}>
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <Box sx={layoutPrivateStyle.headerBox1}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={layoutPrivateStyle.headerMenu}
            >
              {linkLists.map((page) => (
                <MenuItem key={page.name} onClick={() => navigate(page.link)}>
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            sx={layoutPrivateStyle.headerBox2}
          >
            <Link href="/" sx={layoutPrivateStyle.headerLink}>
              <Box
                component="img"
                src="/assets/logo/logo-binusuniv.svg"
                sx={layoutPrivateStyle.headerImg}
              />
            </Link>
            <Link href="/" sx={layoutPrivateStyle.headerLink} underline="none" textTransform="none">
              <Typography sx={layoutPrivateStyle.headerTypography}>BEEMINE</Typography>
            </Link>
          </Box>

          <Box sx={layoutPrivateStyle.headerBox3}>
            {linkLists.map((page) => {
              if (page.name === "User" && profile.role !== "Admin") {
                return null
              }

              return (
                <Button
                  key={page.name}
                  onClick={() => {
                    setActiveMenu(page.name)
                    navigate(page.link)
                  }}
                  sx={{ my: 2, color: activeMenu === page.name ? 'black' : '#999999', display: 'block', fontWeight: '600' }}
                >
                  {page.name}
                </Button>
              )
            })}
          </Box>
          <Stack direction="row" sx={layoutPrivateStyle.headerStack}>
            <Stack
              sx={layoutPrivateStyle.headerStack2}
              onClick={() => setShowNotification(!showNotification)}
            >
              <IconButton
                sx={{
                  width: '32px',
                  height: '32px',
                  background: showNotification ? '#E6E6E6' : 'transparent',
                  ':hover': {
                    background: '#E6E6E6',
                  },
                }}
              >
                <Badge badgeContent="" color="error" variant="dot" invisible={badgeInvisible}>
                  <NotificationsIcon sx={layoutPrivateStyle.headerNotificationsIcon} />
                </Badge>
              </IconButton>
            </Stack>

            <Avatar
              src={profile?.avatar}
              sx={layoutPrivateStyle.headerAvatar}
              onClick={() => setProfileMenu?.(!profileMenu)}
            />
          </Stack>
          <Notification
            showNotification={showNotification}
            setShowNotification={setShowNotification}
            setBadgeInvisible={setBadgeInvisible}
            badgeInvisible={badgeInvisible}
          />
          <Backdrop
            sx={layoutPrivateStyle.headerBackdrop}
            open={profileMenu}
            onClick={() => setProfileMenu?.(!profileMenu)}
          >
            <Box sx={layoutPrivateStyle.headerBox5}>
              <ModulProfileMenu profileMenu={profileMenu} setProfileMenu={setProfileMenu} />
            </Box>
          </Backdrop>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
